import { render, staticRenderFns } from "./tradeOrderModal.vue?vue&type=template&id=67356b44&scoped=true&"
import script from "./tradeOrderModal.vue?vue&type=script&lang=js&"
export * from "./tradeOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67356b44",
  null
  
)

export default component.exports